import { RoundImg } from "./styles";

const RoundSymbol = ({src, alt}) => {

    return (
        <RoundImg src={src} alt={alt} />
    )

}

export default RoundSymbol;